/**
 * @file   知识问答
 * @create macaiqi 2021/11/30
 * @update
 */
import React, { useEffect,useCallback, useMemo, useRef, useState } from 'react';
import { questionAnswer,autoComplete } from '../../../shared/api';
import cls from 'classnames';
import './index.scss';
//  底部表单
const Ipt = ({ fetchAnswer }) => {
  const [question, setquestion] = useState();
  const [showTip, setshowTip] = useState(false);
  const [tipList, setTipList] = useState([]);
  useEffect(() => {
    // let datas = [
    //   '徽派建筑特点',
    //   '徽派建筑分布在哪些地方',
    //   '徽派建筑代表建筑群',
    //   '徽派建筑与苏派建筑的区别',
    //   '徽派建筑与赣派建筑的区别'
    // ]
    // setTipList(datas);
  }, [])
  const handleClick = () => {
    if (question) {
      setquestion('');
      fetchAnswer(question);
      setshowTip(false);
      setTipList([]);
    }
  }
  // const handleClick = useCallback(async () => {
  //   if (question) {
  //     setshowTip(false);
  //     setquestion('');
  //     fetchAnswer(question);
  //     setTipList([]);
  //   }
  // }, [fetchAnswer, question]);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.charCode === 0 && e.keyCode === 13) {
        if (question) {
          setshowTip(false);
          setquestion('');
          fetchAnswer(question);
          setTipList([]);
        }
      }
    },
    [fetchAnswer, question]
  );
  const getTipList = (val) => {
    const keyword = val.trim('');
    autoComplete(keyword,1,8).then((res)=>{
      if(res && res.length>0){
        setTipList(res);
        setshowTip(true);
      }else{
        setTipList([]);
        setshowTip(false);
      }
    })
  };
  return (
    <div className="question-bg">
      <input
        type="text"
        name=""
        placeholder="请用一句话描述你的问题"
        value={question}
        onKeyDown={handleKeyDown}
        onChange={(e) => {
          setquestion(e.target.value);
          getTipList(e.target.value);
        }}
        onBlur={()=>{
          // setshowTip(false);
        }}
      />
      <div
        className="submit"
        onClick={() => {
          handleClick();
        }}
      />
      <div className={cls("tipList", {showTip: showTip})}>
        <ul>
          {
            tipList?.map((item,index) => {
              return (
                <li key={index} onClick={() => {
                  setshowTip(false); 
                  setquestion('');
                  fetchAnswer(item); 
                }}>{item}</li>
              )
            })
          }
        </ul>
      </div>
    </div>
  );
};
const Question = () => {
  // eslint-disable-next-line no-array-constructor
  const [data, setData] = useState([]);
  const scrollAnchorRef = useRef(null);
  const hotQuestions = useMemo(
    () => [
      '徽州古建筑有什么特色？',
      '什么是徽州“古建三绝”？',
      '什么是徽州“三雕”？',
      '徽州有哪些著名的古建筑？',
      '安徽博物院有什么馆藏三雕文物？',
      '罗东舒祠创建于何时？',
      '许国石坊上有什么纹饰？',
      '奕世尚书坊中的“尚书”指谁？',
      '什么是“马头墙”？',
      '魁星点斗有什么寓意？'
    ],
    []
  );
  const fetchAnswer = useCallback(
    async (q) => {
      const res = await questionAnswer({ text: q });
      const answer = res?.efResult?.answerText || res?.qadbResult;
      setData([...data, { Q: q, A: answer }]);
      // console.log(scrollAnchorRef.current)
      // 每次回答完问题平滑滚动到对话框最底部
      setTimeout(() => {
        scrollAnchorRef.current.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    },
    [data]
  );

  return (
    <div className="questionbox">
      <div className="main">
        <div className="bg">
          {/* 问答列表 */}
          <div className="content-begin">
            <div className="questionList">
              <div className="questionItem robot">
                <div className="img" />
                <div className="content">
                  您好，我是安小博，您可以问我跟徽州古建筑相关的问题，我会尽量解答。
                </div>
              </div>
              {data?.map((item, index) => {
                return (
                  <div className="item" key={index}>
                    {item.Q && (
                      <div className="questionItem mine">
                        <div className="content">{item.Q}</div>
                        <div className="img" />
                      </div>
                    )}
                    {item.A ? (
                      <div className="questionItem robot">
                        <div className="img" />
                        <div className="content" dangerouslySetInnerHTML={{ __html: item.A }} />
                      </div>
                    ) : (
                      <>
                        <div className="questionItem robot">
                          <div className="img" />
                          <div className="content">
                            很抱歉，没有理解您的问题，您可以问：
                            {hotQuestions.map((q, idx) => (
                              <div
                                style={{
                                  color: 'rgb(13, 120, 210)',
                                  cursor: 'pointer',
                                  marginBottom: '5px'
                                }}
                                key={idx}
                                onClick={() => {
                                  fetchAnswer(q);
                                }}
                              >
                                {q}
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* <div className="questionItem robot">
                      <div className="img" />
                      <div
                        className="content"
                      >
                        很抱歉，当前问题找不到答案。
                      </div>
                    </div> */}
                      </>
                    )}
                  </div>
                );
              })}
              <div ref={scrollAnchorRef} style={{ height: '0px', overflow: 'hidden' }} />
            </div>
          </div>
          <Ipt fetchAnswer={fetchAnswer} />
        </div>

        <div className="hot">
          <div className="completeList scroll_bar">
            <div className="tip">热门搜索：</div>
            {hotQuestions.map((q, idx) => (
              <span
                key={idx}
                onClick={() => {
                  fetchAnswer(q);
                }}
              >
                {q}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Question;
